
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(689|901|990)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
